import VisitorScanBadgeStep from './VisitorScanBadgeStep';

export default VisitorScanBadgeStep;

